<template>
  <div class="col-lg-8 offset-lg-2 page">
    <div class="row">
      <allergy-filter :arrayToFilter="allAllergies" :type="type"
                          v-on:update-keywords="updateKeywords"
                          v-on:filter-allergies="updateFilterResults">

      </allergy-filter>

      <allergy-sort :arrayToSort="filteredAllergies
                        ? filteredAllergies : allAllergies"
                        v-on:sortArray="updateSortedResults">

      </allergy-sort>
    </div>

    <allergy-detail :keywords="keywords"
                    :allergies="filteredAllergies">
    </allergy-detail>
      

    <!-- <ul>
        <li v-for="(allergy, index) in filteredAllergies"
            :key="index"
            class="text-capitalize list__item">

          <allergy-detail :keywords="keywords"
                              :allergy="allergy">
          </allergy-detail>
            
        </li>
      </ul> -->
  </div>
</template>

<script>
  import FilterPage from '../_partials/filter/FilterPage';
  import SortPage from '../_partials/sort/SortPage';
  import AllergyDetail from './AllergyDetail';
  import {mapGetters} from 'vuex';
  import {getAllAllergies} from '@/data/getters.js';

  export default {
    name: "allergy-page",
    components: {
      'allergy-filter': FilterPage,
      'allergy-sort': SortPage,
      'allergy-detail': AllergyDetail,
    },
    data() {
      return {
        filteredAllergies: [],
        keywords: [],
        type: 'ALLERGY',
      }
    },
    computed: {
      ...mapGetters('login', {
        allData: 'getAllData',
      }),
      allAllergies: function () {
        return getAllAllergies(this.allData);
      }
    },
    mounted() {
      this.filteredAllergies = this.allAllergies;
    },
    methods: {
      updateKeywords(data) {
        this.keywords = data;
      },
      updateFilterResults(data) {
        this.filteredAllergies = data;
      },
      updateSortedResults(data) {
        this.filteredAllergies = data;
      }
    }
  }
</script>

<style scoped lang="scss">
  ul {
    list-style-type: none;
    padding: 0;
  }
  .list__item {
    padding: 0.75em 1.25em;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    margin-bottom: 0.75em;
  }
  .page {
    max-width: 800px;
  }
</style>